import React from 'react';

const DeviceTitle = ({ record }) => {
	return <span>Device Task {record ? `"${record.id}"` : ''}</span>;
};
export default DeviceTitle;
